{
  "@context": "https://schema.org",
  "@type": "Game",
  "name": "CS Jackpot",
  "alternateName": [
    "csgo roulette", "cs go roulette", "cs go jackpot", "cs2 roulette", "cs2 jackpot",
    "jackpot cs go", "jackpot cs2", "roulette csgo", "roulette cs go", "cs skins roulette",
    "csgo jackpot", "jackpot csgo", "csgo jackpot site"
  ],
  "description": "A high-stakes jackpot game where players deposit CS skins, and one lucky winner takes all.",
  "url": "https://6cs.fail/en/jackpot"
}
